import React from 'react';
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import './PhoneNumberField.css';

const PhoneNumberField = ({
    phone,
    country,
    onPhoneChange,
    error
}) => {
    const handlePhoneChange = (phoneValue, meta = {}) => {
        const selectedCountry = meta.country || {};
        onPhoneChange(phoneValue, {
            countryIso: selectedCountry.iso2,
            countryCode: selectedCountry.dialCode ? `+${selectedCountry.dialCode}` : ''
        });
    };

    return (
        <div className="mb-3 phone-input-wrapper">
            <PhoneInput
                value={phone}
                onChange={handlePhoneChange}
                defaultCountry={country}
                excludeCountries={['il']}
                customCountries={[
                    {
                        name: 'Palestine',
                        iso2: 'ps',
                        dialCode: '970',
                        format: '... ... ...',
                        priority: 0,
                        areaCodes: []
                    }
                ]}
                inputClassName="form-control"
                containerClassName="phone-input-container"
                inputProps={{
                    id: 'phone',
                    placeholder: 'Your Mobile'
                }}
            />
            {error && <div className="invalid-feedback d-block">{error}</div>}
        </div>
    );
};

export default PhoneNumberField;
